import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const BadgeRoot = styled('div', {
  name: 'Badge',
  slot: 'Root',
  overridesResolver: (props, styles) => [
    styles.root,
    props.ownerState.variant && styles[props.ownerState.variant],
  ],
})(({ theme, ownerState }) => ({
  // Base styles
  display: 'inline-block',
  borderRadius: '50%',
  lineHeight: 1.6,
  fontWeight: 600,
  textAlign: 'center',
  width: 16,
  height: 16,
  fontSize: 10,
  // Variant styles
  ...(ownerState.variant === 'filled' && {
    backgroundColor: theme.palette[ownerState.color]?.main,
    color: theme.palette[ownerState.color]?.contrastText,
  }),
  ...(ownerState.variant === 'outlined' && {
    backgroundColor: theme.palette[ownerState.color]?.subtle,
    border: `1px solid ${theme.palette[ownerState.color]?.subtleBorder}`,
    color: theme.palette[ownerState.color]?.main,
  }),
}));

const Badge = ({ value, color = 'primary', variant = 'filled', ...other }) => {
  const ownerState = { color, variant };

  return (
    <BadgeRoot variant="small" ownerState={ownerState} {...other}>
      {value}
    </BadgeRoot>
  );
};

Badge.propTypes = {
  value: PropTypes.number.isRequired,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'warning',
    'info',
    'success',
  ]),
  variant: PropTypes.oneOf(['filled', 'outlined']),
};

export default Badge;
